import React from 'react';
import './Footer.css';

function AboutUs() {
  return (
    <section className="footer-section about-section" id="about">
      <div className="section-icon">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <circle cx="12" cy="12" r="10" />
          <path d="M12 16v-4M12 8h.01" />
        </svg>
      </div>
      <h2 className="section-title">About Karma Rankings</h2>
      <p className="section-description">
        Karma Rankings is a community-driven platform where users can vote on public figures
        to reflect their reputation based on actions, contributions, and public perception.
        Our goal is to create a transparent and engaging way to recognize those who make
        a positive impact—and hold accountable those who don't.
      </p>
      <div className="section-features">
        <div className="feature-item">
          <span className="feature-icon">🌍</span>
          <span className="feature-text">Global Community</span>
        </div>
        <div className="feature-item">
          <span className="feature-icon">🗳️</span>
          <span className="feature-text">Democratic Voting</span>
        </div>
        <div className="feature-item">
          <span className="feature-icon">📊</span>
          <span className="feature-text">Real-time Rankings</span>
        </div>
      </div>
    </section>
  );
}

export default AboutUs;
